<app-idea-card
  *ngFor="let idea of ideas || session.data.ideas"
  [idea]="idea"
  [session]="session"
  [small]="true"
  [nopreview]="true"
  [pickable]="true"
  [picked]="isPicked(idea)"
  (pickedChange)="toggle(idea)"></app-idea-card>
